import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  codeWordsValidated: false,
  selectedNewspaper: '',
  availableDates: [],
};

const codeWordsSlice = createSlice({
  name: 'codeWords',
  initialState,
  reducers: {
    setCodeWordsValidated(state) {
      state.codeWordsValidated = true;
    },
    setNewspaper(state, action) {
      state.selectedNewspaper = action.payload;
    },
    setAvailablePromoDates(state, action) {
      state.availableDates = action.payload;
    },
  },
});

export const { setCodeWordsValidated, setNewspaper, setAvailablePromoDates } = codeWordsSlice.actions;

export const codeWordsReducer = codeWordsSlice.reducer;

export const codeWordsValidatedSelector = (state) => state.codeWords.codeWordsValidated;
export const selectedNewspaperSelector = (state) => state.codeWords.selectedNewspaper;
